module.exports = __webpack_public_path__ + "static/media/map.381fc871.png";